import React from "react";
import { Col, Card } from "antd";
import { Chart, Geom, Axis, Tooltip, Legend } from "bizcharts";
import EmptyData from "./emptyData";
import ChartHelp from "./chartHelp";
import DataSet from "@antv/data-set";

interface Props {
    metadata: any;
    dataSource: {
        name: string;
        data: {
            [key: string]: number;
        };
    }[];
}

const ProportionBarChart = ({ metadata, dataSource }: Props) => {
    let data: any[] = [],
        fields: string[] = [];

    if (dataSource && dataSource.length !== 0) {
        data = dataSource.map((item) => {
            let data: any = {};
            Object.keys(item.data).forEach((key) => {
                data[key] = Number(item.data[key]);
                if (!fields.includes(key)) {
                    fields.push(key);
                }
            });

            return {
                name: item.name,
                ...data,
            };
        });
    }

    if (metadata.checkData && !dataSource) {
        return null;
    }

    const ds = new DataSet();
    const dv = ds.createView().source(data);
    dv.transform({
        type: "fold",
        fields,
        key: "cuidado",
        value: "total",
    });

    return (
        <Col xs={24} md={metadata?.colSize || 12}>
            <Card
                size="small"
                title={metadata.title ? metadata.title : " "}
                extra={metadata.help ? <ChartHelp text={metadata.help} /> : null}
                className={"qa-title-dashboard"}
            >
                {!dataSource || dataSource.length === 0 ? (
                    <EmptyData />
                ) : (
                    <Chart height={400} data={dv} forceFit>
                        <Legend />
                        {/* <TotalValues label={metadata.labelTotal} total={total.toFixed(2)} /> */}
                        <Axis name="Cuidados" />
                        <Axis name="total" />
                        <Tooltip
                            shared={true}
                            hideMarkers={true}
                            crosshairs={{
                                type: "y",
                            }}
                        />

                        <Geom
                            type="intervalStack"
                            // adjust="stack"
                            position="cuidado*total"
                            color={"name"}
                            tooltip={[
                                "total",
                                (total) => {
                                    return {
                                        name: `${metadata.verticalLabel}: ${total}`,
                                        value: total,
                                        title: "label",
                                    };
                                },
                            ]}
                        />
                    </Chart>
                )}
            </Card>
        </Col>
    );
};

export default ProportionBarChart;
